import script from "./AppDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./AppDeleteModal.vue?vue&type=style&index=0&id=64398d0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64398d0a"]])

export default __exports__